"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { DestinationCard } from "./DestinationCard";
import { groupDestinations } from "./utils";
import { PopularDestination } from "@/types/popular-destination";

interface PopularUserDestinationsCarouselProps {
  destinations: PopularDestination[];
}

export const PopularUserDestinationsCarousel = ({
  destinations,
}: PopularUserDestinationsCarouselProps) => {
  // Group by 4 rows per column for carousel effect
  const groupedDestinations = groupDestinations(destinations, 4);

  if (destinations.length === 0) {
    return null;
  }

  return (
    <Carousel
      opts={{
        align: "start",
        loop: false,
        dragFree: true,
      }}
      dir="rtl"
      className="w-full pr-5 md:pr-0"
    >
      <CarouselContent className="-mr-3 lg:-mr-4">
        {groupedDestinations.map((group, groupIndex) => (
          <CarouselItem
            key={groupIndex}
            className="basis-[52%] sm:basis-[52%] md:basis-[38%] lg:basis-1/4 pl-3 lg:pl-4 pr-3 lg:pr-4"
          >
            <div className="flex flex-col gap-4">
              {group.map((destination, destIndex) => (
                <DestinationCard
                  key={`${destination.citySlug}-${groupIndex}-${destIndex}`}
                  destination={destination}
                />
              ))}
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};

